import React, { useEffect, useState } from 'react'
import HomeThumbnails from '../components/HomeThumbnails'
import axios from 'axios';
import API_URL from "../config";

const Home = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  const fetchVideos = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/videos`);
      console.log("Frontend received:", res.data); // Add this
      setVideos(res.data?.videos || []); // make sure you’re using the right property
    } catch (err) {
      console.error("Failed to load videos:", err);
      setError("Failed to load videos");
    } finally {
      setLoading(false);
    }
  };

    fetchVideos();
  }, []);

  if (loading) return <p className="text-center mt-8">Loading videos...</p>;
  if (error) return <p className="text-center mt-8 text-red-500">{error}</p>;
  if (!videos.length) return <p className="text-center mt-8">No videos available</p>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 p-4">
      {videos.map((video) => (
        <HomeThumbnails
          key={video._id}
          id={video._id}
          src={video.thumbnailUrl || "https://via.placeholder.com/300x200?text=No+Thumbnail"}
          title={video.title}
          publisher={video.publisher}
        />
      ))}
    </div>
  );
};

export default Home
